(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header') || this.closest('.section-header') || this;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = { top: 0, bottom: 80 };

      // Ensure previous sticky state classes are cleaned up on initialization or setting change
      this.header.classList.remove('shopify-section-header-hidden', 'scrolled-past-header', 'animate');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      } else {
        this.header.classList.remove('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.onSectionSelect = (event) => {
        if (this.contains(event.target) || (this.header && this.header.contains(event.target))) {
          this.reveal();
        }
      };
      document.addEventListener('shopify:section:select', this.onSectionSelect);
      document.addEventListener('shopify:section:load', this.onSectionSelect);

      this.createObserver();
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:section:load', this.onSectionSelect);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries[0]) {
          const rect = entries[0].boundingClientRect;
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          this.headerBounds = {
            top: rect.top + scrollTop,
            bottom: rect.bottom + scrollTop
          };
        }
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop) {
        if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        } else {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'scrolled-past-header', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'scrolled-past-header', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'scrolled-past-header', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || (this.header ? this.header.querySelectorAll('header-menu') : []);
      if (this.disclosures) {
        this.disclosures.forEach(disclosure => disclosure.close());
      }
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || (this.header ? this.header.querySelector('details-modal') : null);
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header') || this.closest('.section-header') || this;
      if (this.header) {
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'scrolled-past-header', 'animate');
      }
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vslf-signup-panel')) {
  customElements.define('vslf-signup-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.storageKey = 'vslf-signup-dismissed-' + window.location.host;
      this.subscribedKey = 'promo-bar-subscribed-' + window.location.host;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-signup-close]').forEach(button => button.addEventListener('click', () => this.close(), options));
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      }, options);
      const success = this.querySelector('[data-signup-success]');
      const error = this.querySelector('[data-signup-error]');
      const testing = this.dataset.mode === 'testing' || this.dataset.mode === 'success_testing';
      if (success) {
        if (!testing) this.writeStorage(this.subscribedKey, JSON.stringify({subscribed:true}));
        this.querySelector('[data-signup-copy]').addEventListener('click', async () => {
          const input = this.querySelector('[data-signup-code]');
          const feedback = this.querySelector('[data-signup-feedback]');
          try { await navigator.clipboard.writeText(input.value); feedback.textContent = feedback.dataset.success; }
          catch { input.focus(); input.select(); feedback.textContent = feedback.dataset.failure; }
        }, options);
      }
      if (success || error || testing) { this.open(); return; }
      if (this.readStorage(this.subscribedKey)) return;
      const until = Number(this.readStorage(this.storageKey));
      if (until > Date.now()) return;
      this.timer = setTimeout(() => {
        if (document.activeElement?.matches('input,textarea,select') || document.querySelector('cart-drawer.active,dialog[open],details[open]')) return;
        this.open();
      }, Math.max(0, Number(this.dataset.delay) || 12) * 1000);
    }
    readStorage(key) { try { return localStorage.getItem(key); } catch { return null; } }
    writeStorage(key,value) { try { localStorage.setItem(key,value); } catch {} }
    open() { this.inert = false; requestAnimationFrame(() => this.classList.add('is-open')); }
    close() {
      this.inert = true;
      this.classList.remove('is-open');
      this.writeStorage(this.storageKey,String(Date.now() + (Number(this.dataset.days) || 10) * 86400000));
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.initialized = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v26-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('v26-site-header')) {
  customElements.define('v26-site-header', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.disclosures = [...this.querySelectorAll('[data-v26-disclosure]')];
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.lastY = Math.max(0, window.scrollY);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const y = Math.max(0, window.scrollY);
          const difference = y - this.lastY;
          const focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
          if (y <= this.offsetHeight || focused || this.disclosures.some((item) => item.open)) {
            this.section.classList.remove('v26-header-hidden');
          } else if (Math.abs(difference) > 6) {
            this.section.classList.toggle('v26-header-hidden', difference > 0);
          }
          if (Math.abs(difference) > 6 || y <= this.offsetHeight) this.lastY = y;
        });
      };
      this.resizeObserver = new ResizeObserver(() => {
        this.section.style.setProperty('--v26-notice-height', `${this.querySelector('.v26-announcement').offsetHeight}px`);
        this.section.style.setProperty('--v26-shell-height', `${this.offsetHeight}px`);
      });
      this.resizeObserver.observe(this);
      window.addEventListener('scroll', this.onScroll, { passive: true, signal });
      this.addEventListener('focusin', () => this.section.classList.remove('v26-header-hidden'), { signal });
      this.disclosures.forEach((item) => {
        item.addEventListener('toggle', () => {
          item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
          if (item.open) {
            this.section.classList.remove('v26-header-hidden');
            this.disclosures.forEach((other) => { if (other !== item) other.open = false; });
          }
        }, { signal });
      });
      document.addEventListener('click', (event) => {
        this.disclosures.forEach((item) => {
          if (item.open && !item.contains(event.target)) item.open = false;
        });
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.disclosures.forEach((item) => {
          if (!item.open) return;
          item.open = false;
          item.querySelector('summary').focus();
        });
      }, { signal });
      this.querySelector('.v26-mobile-panel').addEventListener('click', (event) => {
        if (event.target.closest('a')) this.disclosures.forEach((item) => { item.open = false; });
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v27-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
  const startCampaignVideos = (root = document) => {
    root.querySelectorAll('.v27-campaign-video').forEach((video) => {
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      const start = () => {
        if (!video.paused) return;
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      };

      if (video.readyState >= 2) start();
      else video.addEventListener('canplay', start, { once: true });

      window.addEventListener('pageshow', start);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) start();
      });
      document.addEventListener('touchstart', start, { once: true, passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => startCampaignVideos(), { once: true });
  } else {
    startCampaignVideos();
  }

  document.addEventListener('shopify:section:load', (event) => startCampaignVideos(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vslf-drop-products"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('vslf-drop-products'))customElements.define('vslf-drop-products',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.abort=new AbortController();const opts={signal:this.abort.signal};
      this.addEventListener('click',e=>{const opener=e.target.closest('[data-open-product]');if(opener){const dialog=document.getElementById(opener.dataset.openProduct);if(dialog){this.lastOpener=opener;dialog.showModal();}}const closer=e.target.closest('[data-close-product]');if(closer)closer.closest('dialog').close();const thumb=e.target.closest('[data-product-image]');if(thumb){const area=thumb.closest('.drop-dialog__images');area.querySelector('.drop-dialog__main').src=thumb.dataset.productImage;area.querySelectorAll('[data-product-image]').forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));}},opts);
      this.querySelectorAll('dialog').forEach(d=>{d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}},opts);d.addEventListener('close',()=>this.lastOpener?.focus(),opts);});
    }
    disconnectedCallback(){this.abort?.abort();this.ready=false;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vslf-drop-slideshow"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('vslf-drop-slideshow'))customElements.define('vslf-drop-slideshow',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.abort=new AbortController();const opts={signal:this.abort.signal};
      this.slides=[...this.querySelectorAll('.drop-hero__slide')];this.dots=[...this.querySelectorAll('[data-slide]')];this.index=0;
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.dataset.autoplay!=='true'||this.motion.matches;
      this.controls=this.querySelector('.drop-hero__controls');this.pauseButton=this.querySelector('button[data-pause]');
      if(!this.controls)return;this.controls.hidden=false;
      this.querySelector('[data-prev]').addEventListener('click',()=>this.show(this.index-1),opts);
      this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1),opts);
      this.dots.forEach(b=>b.addEventListener('click',()=>this.show(Number(b.dataset.slide)),opts));
      this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.update();},opts);
      this.addEventListener('focusin',e=>{this.focused=e.target.matches(':focus-visible');this.update();},opts);this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');this.update();});},opts);
      this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}},opts);
      this.addEventListener('touchstart',e=>{this.touchX=e.changedTouches[0].clientX;this.touchY=e.changedTouches[0].clientY;},{...opts,passive:true});
      this.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-this.touchX,dy=e.changedTouches[0].clientY-this.touchY;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));},{...opts,passive:true});
      document.addEventListener('visibilitychange',()=>this.update(),opts);
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.update();},opts);
      document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0)this.show(i);},opts);
      this.update();
    }
    show(index){this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>{const active=i===this.index;s.classList.toggle('is-current',active);s.setAttribute('aria-hidden',String(!active));s.inert=!active;});this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)));this.update();}
    update(){clearInterval(this.timer);if(!this.pauseButton)return;this.pauseButton.textContent=this.paused?'▶':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.paused?this.dataset.play:this.dataset.pause);this.querySelector('.drop-hero__slides').setAttribute('aria-live',this.paused?'polite':'off');if(!this.paused&&!this.focused&&!document.hidden&&this.slides.length>1)this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.interval)||6000);}
    disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.ready=false;}
  });

  } catch(e) { console.error(e); }
})();
})();
